// extracted by mini-css-extract-plugin
export default {"rules":"Auth-module__rules--rEuMa","childTitleBr":"Auth-module__childTitleBr--_cZql"};